import {
  documentList,
  DocumentListViewProps,
  DocumentListDocActionProps,
} from 'services/analytics/events';
import { getAnalyticsClient } from 'services/apollo';
import { ProfileFeedAnlayticsQuery } from 'services/apollo/queries';

/*
  View Event
*/

export const trackingDocumentListViewPrimaryFeed = async (totalNodes: number) => {
  const metadata: DocumentListViewProps = {
    '[Document list] Type': 'Primary Feed',
    '[Document list] Total items': totalNodes,
  };
  return documentList.view(metadata);
};

export const trackingDocumentListViewKeywordSearch = (searchTerm: string, totalItems: number) => {
  const metadata: DocumentListViewProps = {
    '[Document list] Type': 'Search Results',
    '[Document list] Total items': totalItems,
    '[Search] Term': searchTerm,
  };
  return documentList.view(metadata);
};

export const trackingDocumentListAppSearch = (appName: string, totalItems: number) => {
  const metadata: DocumentListViewProps = {
    '[Document list] Type': 'App Search',
    '[Document list] App type': appName,
    '[Document list] Total items': totalItems,
  };
  return documentList.view(metadata);
};

export const trackingDocumentListProfileFeed = (
  userId: string,
  filter: any,
  groupsEnabled: boolean
) => {
  const getDataForEvent = getAnalyticsClient().then((client) =>
    client.query({
      query: ProfileFeedAnlayticsQuery,
      variables: { cursor: '', userId: userId, includeGroups: groupsEnabled },
      fetchPolicy: 'cache-first',
    })
  );
  getDataForEvent.then((response) => {
    let metadata: DocumentListViewProps;

    if (filter === 'owned') {
      metadata = {
        '[Document list] Type': 'Profile Feed',
        '[Document list] Total items': response.data.profileByIdentifier?.ownsNodes?.pageInfo.total,
        '[Document list] Person': response.data.profileByIdentifier.name,
        '[Filter] Owned by': response.data.profileByIdentifier.name,
      };
    } else if (filter === 'shared') {
      metadata = {
        '[Document list] Type': 'Profile Feed',
        '[Document list] Total items':
          response.data.profileByIdentifier?.sharedWithNodes?.pageInfo.total,
        '[Document list] Person': response.data.profileByIdentifier.name,
        '[Filter] Shared with': response.data.profileByIdentifier.name,
      };
    } else {
      metadata = {
        '[Document list] Type': 'Profile Feed',
        '[Document list] Total items': response.data.profileByIdentifier?.userNodes?.pageInfo.total,
        '[Document list] Person': response.data.profileByIdentifier.name,
      };
    }

    return documentList.view(metadata);
  });
};

/*
  Select Document
*/

export const trackingDocumentSelectPrimaryFeed = (
  index: number,
  totalItems: number,
  nodeType: string,
  numberOfCollaborators: number
) => {
  const metadata: DocumentListDocActionProps = {
    '[Document list] Type': 'Primary Feed',
    '[Document list] Total items': totalItems,
    '[Document list] Item position': index + 1,
    '[Metadata] Document type': nodeType,
    '[Metadata] Document collaborators': numberOfCollaborators,
  };
  return documentList.openDocument(metadata);
};

export const trackingDocumentSelectIntegrationFeed = (
  index: number,
  totalItems: number,
  nodeType: string,
  numberOfCollaborators: number,
  integration: string
) => {
  const metadata: DocumentListDocActionProps = {
    '[Document list] Type': 'App Search',
    '[Document list] Total items': totalItems,
    '[Document list] Item position': index + 1,
    '[Document list] App type': integration,
    '[Metadata] Document type': nodeType,
    '[Metadata] Document collaborators': numberOfCollaborators,
  };
  return documentList.openDocument(metadata);
};

export const trackingDocumentSelectSearchFeed = (
  index: number,
  totalItems: number,
  nodeType: string,
  numberOfCollaborators: number,
  searchTerm: string
) => {
  const metadata: DocumentListDocActionProps = {
    '[Document list] Type': 'Search Results',
    '[Document list] Total items': totalItems,
    '[Document list] Item position': index + 1,
    '[Search] Term': searchTerm,
    '[Metadata] Document type': nodeType,
    '[Metadata] Document collaborators': numberOfCollaborators,
  };
  return documentList.openDocument(metadata);
};
